import React from "react";
import typographyTokens from "../../styles/tokens/typography";
import { UtilityProps } from "../../types/Typography";

export const Utility: React.FC<UtilityProps> = ({
  variant = "button",
  element,
  align = "left",
  weight,
  color,
  truncate = false,
  lineClamp,
  children,
  className = "",
  style = {},
  onClick,
  testID,
  ...rest
}) => {
  const getDefaultElement = () => {
    switch (variant) {
      case "button":
        return "span";
      case "link":
        return "a";
      case "caption":
        return "span";
      default:
        return "span";
    }
  };

  const elementToUse = element || getDefaultElement();

  const getStyles = (): React.CSSProperties => {
    let tokenSet;
    switch (variant) {
      case "button":
        tokenSet = typographyTokens.labelLg;
        break;
      case "link":
        tokenSet = typographyTokens.labelMd;
        break;
      case "caption":
        tokenSet = typographyTokens.labelSm;
        break;
    }

    let fontWeightValue = parseInt(tokenSet.fontWeight);
    if (weight) {
      if (weight === "normal") fontWeightValue = 400;
      else if (weight === "medium") fontWeightValue = 500;
      else if (weight === "semibold") fontWeightValue = 600;
      else if (weight === "bold") fontWeightValue = 700;
    }

    const baseStyles: React.CSSProperties = {
      fontFamily: tokenSet.fontFamily,
      fontSize: `${tokenSet.fontSize}px`,
      lineHeight: `${tokenSet.lineHeight}px`,
      fontWeight: fontWeightValue,
      color: color || tokenSet.color,
      textAlign: align,
      letterSpacing: tokenSet.letterSpacing,
      textDecoration:
        variant === "link" ? "underline" : tokenSet.textDecoration || "none",
    };

    if (truncate) {
      baseStyles.whiteSpace = "nowrap";
      baseStyles.overflow = "hidden";
      baseStyles.textOverflow = "ellipsis";
      baseStyles.display = "block";
    }

    if (lineClamp && lineClamp > 0) {
      baseStyles.display = "-webkit-box";
      baseStyles.WebkitLineClamp = lineClamp;
      baseStyles.WebkitBoxOrient = "vertical";
      baseStyles.overflow = "hidden";
      baseStyles.textOverflow = "ellipsis";
    }

    return baseStyles;
  };

  const combinedStyles = {
    ...getStyles(),
    ...style,
  };

  const linkProps = elementToUse === "a" ? rest : {};

  const Component = elementToUse as React.ElementType;

  return (
    <Component
      style={combinedStyles}
      className={className}
      data-testid={testID}
      onClick={onClick}
      {...linkProps}
    >
      {children}
    </Component>
  );
};
